import { apiClient } from './apiClient';

class RolesService {
  async getRoles() {
    try {
      const response = await apiClient.get('/roles');
      return { success: true, data: response };
    } catch (error) {
      console.error('Fehler beim Laden der Rollen:', error);
      return {
        success: false,
        error: error.message || 'Rollen konnten nicht geladen werden.',
        data: []
      };
    }
  }

  async getPermissions() {
    try {
      const response = await apiClient.get('/roles/permissions');
      return { success: true, data: response };
    } catch (error) {
      console.error('Fehler beim Laden der Berechtigungen:', error);
      return {
        success: false,
        error: error.message || 'Berechtigungen konnten nicht geladen werden.',
        data: []
      };
    }
  }

  async createRole(payload) {
    try {
      const response = await apiClient.post('/roles', payload);
      return { success: true, data: response };
    } catch (error) {
      console.error('Fehler beim Anlegen der Rolle:', error);
      return {
        success: false,
        error: error.message || 'Rolle konnte nicht angelegt werden.'
      };
    }
  }

  async updateRole(id, payload) {
    try {
      const response = await apiClient.put(`/roles/${id}`, payload);
      return { success: true, data: response };
    } catch (error) {
      console.error('Fehler beim Aktualisieren der Rolle:', error);
      return {
        success: false,
        error: error.message || 'Rolle konnte nicht aktualisiert werden.'
      };
    }
  }

  async deleteRole(id) {
    try {
      const response = await apiClient.delete(`/roles/${id}`);
      return { success: true, data: response };
    } catch (error) {
      console.error('Fehler beim Löschen der Rolle:', error);
      return {
        success: false,
        error: error.message || 'Rolle konnte nicht gelöscht werden.'
      };
    }
  }
}

const rolesService = new RolesService();
export default rolesService;

